export const TARGET_ID = {
  SUPPORT_BUTTON: "supportBtn",
  FAQ: "faq",
  SEND_MESSAGE: "sendMessage",
};
